import classNames from "classnames";
import log from "cslog";
import { useAtom } from "jotai";
import { useState } from "react";
import { actionUIAtom } from "../../../../db";
import { useAction } from "../../../../hooks";
import { decodeStyle, mobile, parseStyle, tablet } from "../../../../juntion";
import styles from "./styles/VerticalMenu.module.css";

// TODO: Style and responsive behaviour
function VerticalMenu({ id, db, gs, device }) {
	const { performAction, currentPage } = useAction();
	const [_, setActionUI] = useAtom(actionUIAtom);
	const [openedSubmenu, setOpenedSubmenu] = useState(null);

	const data = db[id];

	const ps = parseStyle(data, gs, data.cstate);

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	const menuHeight = input.menuHeight + "px";
	const activeColor = "orange";

	const menuColor = "transparent";

	const styleMenu = decodeStyle(ps.mobileGroup.menu, gs);
	const styleMenuItem = decodeStyle(ps.mobileGroup.menuItem, gs);

	const styleSubmenu = decodeStyle(ps.mobileGroup.submenu, gs);
	const styleSubmenuItem = decodeStyle(ps.mobileGroup.submenuItem, gs);

	log.d(input, "NavMenu Input");

	// const checkSelected = (item) => {
	// 	if (item.action?.type === "page") {
	// 		if (item.action.params?.id === selectedPage?.id) {
	// 			return true;
	// 		}
	// 		return false;
	// 	}
	// 	return false;
	// };

	const navItems = input.navItems || input.items;

	// Always keep containing section z-index >3
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div className={styles.menu} style={styleMenu}>
				{navItems.map((item) => {
					return (
						<div className={styles.item} key={item.name}>
							<a
								href="#"
								className={classNames({
									[styles.subBtn]:
										openedSubmenu === item.name,
								})}
								style={styleMenuItem}
								onClick={() => {
									if (
										item.children &&
										item.children.length > 0
									) {
										if (openedSubmenu === item.name) {
											setOpenedSubmenu(null);
										} else {
											setOpenedSubmenu(item.name);
										}
									} else {
										// onMenuCilck(item);
										performAction(item.action);
									}
								}}
							>
								{/* <i className="fas fa-angle-double-right"></i> */}
								<i className={input.iconSource?.value}></i>
								{item.name}
								{item.children && item.children.length > 0 && (
									<i
										className={classNames(
											"fas fa-angle-right",
											styles.dropdown
										)}
										style={{
											transform:
												openedSubmenu === item.name
													? "rotate(90deg)"
													: "none",
										}}
									></i>
								)}
							</a>
							{item.children && item.children.length > 0 && (
								<div
									className={styles.subMenu}
									style={{
										transform:
											openedSubmenu === item.name
												? "none"
												: "scale(1,0)",
										maxHeight:
											openedSubmenu === item.name
												? "max-content"
												: 0,
										// display:
										//     openedSubmenu === "tables" ? "block" : "none",
										...styleSubmenu,
									}}
								>
									{item.children.map((child) => {
										return (
											<a
												key={child.name}
												href="#"
												className={styles.subItem}
												onClick={() =>
													// onMenuCilck(child)
													performAction(child.action)
												}
												style={styleSubmenuItem}
											>
												{child.name}
											</a>
										);
									})}
								</div>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default VerticalMenu;
